import Marionette from "../../shared/marionette-mustache";
import { ReportStatusModel } from "../models/report-status";
import { backboneViewProperties } from "../../decorators/backbone-properties";

const template = require<string>("./report-status.html");

@backboneViewProperties({
    tagName: "li",
    template: template
})
export class ReportStatusView extends Marionette.ItemView<ReportStatusModel> {

    public template: string;
    constructor(options?: Backbone.ViewOptions<ReportStatusModel>) {
        super(options);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/import-status/views/report-status.ts